import { getCrudFieldConfig } from 'utils/fm/fields';

export const getMarketingStatusIdCrudSchemaField = (defaultInputSchema, entity) => ({
    ...defaultInputSchema,
    ...getCrudFieldConfig(entity, 'marketingStatusId'),
    hidden: true,
    readOnly: true,
    type: 'integer',
});
